import {
  Dropdown,
  DropdownLayoutTheme,
  LoadingAnimation,
  SimpleBlock,
  useFilterContext
} from 'ui-builder';
import { ProjectFilter, useTeamSetupAreasService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import React from 'react';
import { NewTransactionsManagementToggleWrapper } from 'feature-toggle';

function SetupAreaFilterWidget() {
  const filterContext = useFilterContext<ProjectFilter>();

  const teamSetupAreaService = useTeamSetupAreasService();

  const { data: setupAreas } = useDataLoaderNew(
    teamSetupAreaService.getTeamSetupAreas,
  );


  if (setupAreas) {
    if (setupAreas.length > 1) {
      return (
        <Dropdown
          source="setupAreaId"
          label="Choose Market"
          value={filterContext.filterValue?.setupAreaId}
          onChangeCallback={(value) => {
            const newFilterValue = {
              ...filterContext.filterValue!,
              setupAreaId: value.setupAreaId,
            };
            filterContext.setFilterValue(newFilterValue);
          }}
          options={[
            {
              value: null,
              label: 'All Markets',
            },
            ...setupAreas.map((item) => ({
              value: item.id,
              label: item.name,
            })),
          ]}
          isClearable={false}
          hideLabel
          layoutTheme={DropdownLayoutTheme.COMPACT}
        />
      );
    } else {
      return null;
    }
  } else {
    return (
      <LoadingAnimation />
    );
  }
}

export function SetupAreaFilter() {
  return (
    <SimpleBlock className="form">
      <NewTransactionsManagementToggleWrapper hideInDevelopment>
        <SetupAreaFilterWidget />
      </NewTransactionsManagementToggleWrapper>
    </SimpleBlock>
  );
}
